(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsc-contact"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initializeContact(root) {
      if (root.dataset.topicReady === 'true') return;
      const topic = root.querySelector('[data-contact-topic]');
      const guidance = root.querySelector('[data-contact-topic-guidance]');
      const order = root.querySelector('[data-contact-order]');
      if (!topic || !guidance || !order) return;
      const form = root.querySelector('form');
      const showroom = root.querySelector('#ContactForm-showroom');
      const orderNumber = root.querySelector('#ContactForm-order');
      const contextKey = 'tsc-contact-context';
      try {
        if (root.querySelector('[data-contact-error]')) {
          const saved = JSON.parse(sessionStorage.getItem(contextKey) || 'null');
          if (saved) {
            if ([...topic.options].some(option => option.value === saved.topic)) topic.value = saved.topic;
            if ([...showroom.options].some(option => option.value === saved.showroom)) showroom.value = saved.showroom;
            orderNumber.value = saved.order || '';
          }
        } else {
          sessionStorage.removeItem(contextKey);
        }
      } catch (_) {}
      form.addEventListener('submit', () => {
        try {
          sessionStorage.setItem(contextKey, JSON.stringify({ topic: topic.value, showroom: showroom.value, order: orderNumber.value }));
        } catch (_) {}
      });
      const updateTopic = () => {
        guidance.textContent = topic.selectedOptions[0]?.dataset.help || '';
        order.hidden = !['order', 'delivery', 'warranty'].includes(topic.selectedOptions[0]?.dataset.topic);
      };
      topic.addEventListener('change', updateTopic);
      root.dataset.topicReady = 'true';
      updateTopic();
    }
    function initializeChat(root) {
      if (root.dataset.chatListening === 'true') return;
      root.dataset.chatListening = 'true';
      const ready = () => {
        const api = window.tidioChatApi;
        if (!api || root.dataset.chatReady === 'true') return;
        root.dataset.chatReady = 'true';
        const mobile = window.matchMedia('(max-width: 749px)');
        let chatOpen = false;
        const sync = () => {
          if (!root.isConnected) return;
          if (mobile.matches && !chatOpen) api.hide();
          else api.show();
        };
        root.querySelectorAll('[data-contact-chat]').forEach(button => {
          button.hidden = false;
          button.addEventListener('click', () => { api.show(); api.open(); });
        });
        const status = root.querySelector('[data-contact-chat-status]');
        if (status) status.hidden = true;
        api.on('open', () => { chatOpen = true; });
        api.on('close', () => { chatOpen = false; if (mobile.matches && root.isConnected) api.hide(); });
        mobile.addEventListener('change', sync);
        sync();
      };
      if (window.tidioChatApi) {
        window.tidioChatApi.on('ready', ready);
        if (typeof window.tidioChatApi.getStatus === 'function' && ['online', 'offline'].includes(window.tidioChatApi.getStatus())) ready();
      } else {
        document.addEventListener('tidioChat-ready', ready, { once: true });
      }
    }
    document.querySelectorAll('.tsc-contact').forEach(root => { initializeContact(root); initializeChat(root); });
    document.addEventListener('shopify:section:load', event => {
      event.target.querySelectorAll('.tsc-contact').forEach(root => { initializeContact(root); initializeChat(root); });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
